export type ProgressStepProps = {
  step: 1 | 2 | 3;
};

const ProgressStep = ({ step }: ProgressStepProps) => (
  <div className={`flex gap-1`} aria-hidden="true">
    <div
      className={`h-1 w-16 ${step >= 1 ? 'bg-samsungBlue' : 'bg-neutral-300'}`}
    />
    <div
      className={`h-1 w-16 ${step >= 2 ? 'bg-samsungBlue' : 'bg-neutral-300'}`}
    />
    <div
      className={`h-1 w-16 ${step >= 3 ? 'bg-samsungBlue' : 'bg-neutral-300'}`}
    />
  </div>
);

export default ProgressStep;
